import React, { Component } from 'react';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../custom/FormicaSearchSelectBox';
import FormicaLabel from '../../custom/FormicaLabel';
import { TransactionJsonModel } from '../../../domain/stream/transaction/TransactionDomains';
import { RootState } from '../../../redux/store';
import { StreamState } from '../../../redux/reducers/StreamReducer';
import { changeStream } from '../../../redux/actions/StreamActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import DataType from 'constant/DataType';
import _ from 'lodash';
import CustomLoading from '../../custom/CustomLoading';
import RoleHelper from '../../../RoleHelper';
import LanguageUtil from '../../../util/LanguageUtil';
import ComponentName from '../../../constant/ComponentName';

class StreamColumnCreatorComponent extends Component<Props, State> {
  public state = new State();

  public render() {
    const {
      stream: { stream },
      transactions,
    } = this.props;
    if (transactions == undefined) {
      return <CustomLoading />;
    }
    return (
      <div className={'flex gap-y-3 flex-col items-center w-full'}>
        <div className={'flex flex-col gap-y-1 w-full'}>
          <FormicaLabel label={LanguageUtil.get({ id: `common.label.transaction`, defaultMessage: 'Transaction' })} />
          <FormicaSearchSelectBox
            rounded
            icon={'transaction'}
            disabled={!RoleHelper.canEdit('Stream')}
            value={stream.transaction}
            onChange={(e: FormicaSelectBoxItem | undefined) => {
              this.onChangeTransaction(e);
            }}
            placeholder={LanguageUtil.get({ id: `common.label.transaction`, defaultMessage: 'Transaction' })}
            options={this.getTransactionOptions()}
            data-testid={`${ComponentName.STREAM}_channel_select`}
          />
        </div>
        <div className={'flex flex-col gap-y-1 w-full'}>
          <FormicaLabel label={LanguageUtil.get({ id: `common.label.rowTimeField`, defaultMessage: 'Row Time Field' })} />
          <FormicaSearchSelectBox
            rounded
            disabled={!RoleHelper.canEdit('Stream')}
            value={stream.rowTime}
            icon={'calendar'}
            onChange={(e: FormicaSelectBoxItem | undefined) => {
              this.onChangeRowTime(e);
            }}
            showClear
            placeholder={LanguageUtil.get({ id: `common.label.rowTimeField`, defaultMessage: 'Row Time Field' })}
            options={this.getRowTimeFields()}
            data-testid={`${ComponentName.STREAM}_row_time_select`}
          />
        </div>
      </div>
    );
  }

  public componentDidMount() {
    const {
      stream: { stream },
    } = this.props;
    const { transactions } = this.props;
    if (transactions != undefined) {
      const transaction: TransactionJsonModel = transactions.find((transaction) => transaction.name === stream.transaction) as TransactionJsonModel;
      this.setState({ selectedTransaction: transaction });
    }
  }

  private getTransactionOptions = (): FormicaSelectBoxItem[] => {
    const { transactions } = this.props;
    return transactions?.map((transaction) => {
      return { label: transaction.name, value: transaction.name };
    });
  };

  private onChangeTransaction = (event: FormicaSelectBoxItem | undefined) => {
    const { transactions } = this.props;
    const {
      stream: { stream },
      changeStream,
      update,
    } = this.props;
    if (event == undefined) return;
    const transaction: TransactionJsonModel = transactions.find((transaction) => transaction.name === event.value) as TransactionJsonModel;
    stream.transaction = transaction.name;
    changeStream(stream);
    this.setState({ selectedTransaction: transaction }, () => {
      update();
    });
  };

  private getRowTimeFields = (): FormicaSelectBoxItem[] => {
    const { selectedTransaction } = this.state;
    const options = selectedTransaction?.variables?.map((column) => {
      if (column.properties.dataType == DataType.DATE) {
        return { label: column.name, value: column.name };
      }
    });
    return _.compact(options);
  };

  private onChangeRowTime = (event: FormicaSelectBoxItem | undefined) => {
    const {
      stream: { stream },
      changeStream,
    } = this.props;
    stream.rowTime = event?.value;
    changeStream(stream);
  };
}

interface Props extends ReduxProps {
  update: () => void;
  transactions: TransactionJsonModel[];
}

class State {
  selectedTransaction: TransactionJsonModel | undefined;
}

const mapStateToProps = (state: RootState) => ({
  stream: state.stream as StreamState,
  lastCategory: state.page.lastCategory,
});

const mapDispatchToProps = { changeStream };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(StreamColumnCreatorComponent);
